import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'
import '@/styles/element-variables.scss'
import '@/styles/index.scss'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/icons/components'
import * as filters from '@/filters'

import '@/permission'
import '@/utils/tools'

import EventBus from 'vue-bus-ts'

Vue.use(EventBus)
const bus = new EventBus.Bus()

Vue.use(ElementUI, {
  zIndex: 3000
})
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string ]: Function })[key])
})

Vue.config.productionTip = false

new Vue({
  bus,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
